/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsListBuildLogsRequests {
    getFixupPrototypeFunction() { return AzureDevOpsListBuildLogsRequests.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsListBuildLogsRequests>): AzureDevOpsListBuildLogsRequests {
        let obj = Object.assign(new AzureDevOpsListBuildLogsRequests(), model);
        AzureDevOpsListBuildLogsRequests.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsListBuildLogsRequests>): AzureDevOpsListBuildLogsRequests {
        if (!model) return null;
        return AzureDevOpsListBuildLogsRequests.newInstance(<AzureDevOpsListBuildLogsRequests> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsListBuildLogsRequests) {
        if (!obj) return;

        models.AzureDevOpsListBuildLogsRequests.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsListBuildLogsRequests): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsListBuildLogsRequests.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.build_id === undefined) {
            this.build_id = 0;
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Azure Devops Project ID
     */
    project_id: string;

    /**
     * Azure Devops Build ID
     */
    build_id: number;

}
